/* Vitalitate Naturala — pagina de produs + upsell in cart drawer. Fara dependinte; foloseste <cart-drawer> din Dawn. */
(function () {
  'use strict';

  function money(cents) {
    var f = (document.getElementById('vp') || {}).dataset || {};
    var fmt = f.moneyFormat || '{{amount_with_comma_separator}} lei';
    var n = Math.round(cents);
    var s = Math.floor(n / 100) + ',' + ('0' + (n % 100)).slice(-2);
    // formatul Shopify: {{amount}} / {{amount_with_comma_separator}} / {{amount_no_decimals}}
    if (fmt.indexOf('amount_no_decimals') > -1) s = String(Math.round(n / 100));
    else if (fmt.indexOf('amount_with_comma_separator') === -1) s = s.replace(',', '.');
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  /* adauga unul sau mai multe articole si deschide drawerul temei cu sectiunile re-randate */
  function addItems(items, btn) {
    var d = drawer();
    var body = { items: items };
    if (d && d.getSectionsToRender) {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { alert(res.description || res.message || 'Nu am putut adăuga produsul.'); return res; }
      if (d && d.renderContents) {
        d.classList.remove('is-empty');
        d.renderContents(res);
        setTimeout(function () { var it = d.querySelector('cart-drawer-items'); if (it) it.scrollTop = 0; }, 60);
      } else {
        window.location.href = '/cart';
      }
      try { document.dispatchEvent(new CustomEvent('vita:added', { detail: res })); } catch (e) {}
      return res;
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ---------- pagina de produs ---------- */
  function initProduct() {
    var root = document.getElementById('vp');
    if (!root) return;
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="vp-format"]'));
    var now = document.getElementById('vp-now'), per = document.getElementById('vp-per'), save = document.getElementById('vp-save');
    var atcPrice = document.getElementById('vp-atc-price'), stickyP = document.getElementById('vp-sticky-p');
    var addon = document.getElementById('vp-addon');
    var track = document.getElementById('vp-track');

    function selected() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }

    function qtySel() { var q = root.querySelector('input[name="vp-qty"]:checked'); return q ? { n: parseInt(q.value, 10) || 1, pct: parseInt(q.dataset.pct, 10) || 0 } : { n: 1, pct: 0 }; }
    function totalCents() {
      var s = selected(); if (!s) return 0;
      var qs = qtySel();
      var t = Math.round((parseInt(s.dataset.price, 10) || 0) * qs.n * (100 - qs.pct) / 100);
      if (addon && addon.checked) t += Math.round((parseInt(addon.dataset.price, 10) || 0) * 0.90);
      return t;
    }

    /* produsul atasat urmeaza formatul ales: plic ↔ plic, borcan/set ↔ borcan */
    function syncAddon(s) {
      var w = document.getElementById('vp-addon-wrap'); if (!w || !addon || !w.dataset.plicId) return;
      var plic = /plic/i.test(s.dataset.title || '') && !/set/i.test(s.dataset.title || '');
      var k = plic ? 'plic' : 'jar';
      addon.value = w.dataset[k + 'Id']; addon.dataset.price = w.dataset[k + 'Price'];
      var vt = document.getElementById('vp-addon-vt'), pr = document.getElementById('vp-addon-pr'), im = document.getElementById('vp-addon-banner');
      if (vt) vt.textContent = w.dataset[k + 'Title'];
      if (pr) pr.textContent = money(parseInt(w.dataset[k + 'Price'], 10) || 0);
      if (im && w.dataset[k + 'Img']) im.src = w.dataset[k + 'Img'];
    }
    function refresh() {
      var s = selected(); if (!s) return;
      syncAddon(s);
      var price = parseInt(s.dataset.price, 10), n = parseInt(s.dataset.portii, 10) || 1, econ = parseInt(s.dataset.econ, 10) || 0;
      if (now) now.textContent = money(price);
      if (per) per.textContent = n > 1 ? money(price / n) + ' / porție' : '';
      if (save) { save.hidden = econ < 5; save.textContent = 'economisești ' + econ + '% față de ' + ((root.dataset.basePortii || '1') === '1' ? 'plicul individual' : 'formatul mic'); }
      if (atcPrice) atcPrice.textContent = money(totalCents());
      if (stickyP) stickyP.textContent = s.dataset.title + ' · ' + money(price);
      // URL cu varianta (pentru share / back)
      try { var u = new URL(window.location.href); u.searchParams.set('variant', s.value); history.replaceState(null, '', u.toString()); } catch (e) {}
      // galeria: sare la poza variantei
      var mid = s.dataset.media;
      if (mid && track) {
        var item = track.querySelector('[data-media-id="' + mid + '"]');
        if (item) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', refresh); });
    Array.prototype.forEach.call(root.querySelectorAll('input[name="vp-qty"]'), function (r) { r.addEventListener('change', refresh); });
    if (addon) addon.addEventListener('change', refresh);

    function add(btn) {
      var s = selected(); if (!s || s.dataset.available === 'false') return;
      var items = [{ id: parseInt(s.value, 10), quantity: qtySel().n }];
      if (addon && addon.checked) items.push({ id: parseInt(addon.value, 10), quantity: 1 });
      addItems(items, btn);
    }
    var form = document.getElementById('vp-form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(document.getElementById('vp-atc')); });
    var sb = document.getElementById('vp-sticky-btn');
    if (sb) sb.addEventListener('click', function () { add(sb); });

    // bara lipicioasa: apare cand butonul principal iese din ecran
    var sticky = document.getElementById('vp-sticky'), atc = document.getElementById('vp-atc');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var vis = en[0].isIntersecting;
        var below = en[0].boundingClientRect.top < 0; // a trecut in sus de ecran
        sticky.classList.toggle('is-on', !vis && below);
        sticky.setAttribute('aria-hidden', vis || !below ? 'true' : 'false');
      }, { threshold: 0 }).observe(atc);
    }

    // galerie: puncte + miniaturi
    var dots = Array.prototype.slice.call(document.querySelectorAll('#vp-dots button, #vp-thumbs button'));
    var items = track ? Array.prototype.slice.call(track.children) : [];
    function mark(i) {
      dots.forEach(function (b) { b.setAttribute('aria-current', parseInt(b.dataset.i, 10) === i ? 'true' : 'false'); });
    }
    dots.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.dataset.i, 10);
        if (items[i]) track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    if (track) {
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          mark(Math.min(i, items.length - 1));
        }, 80);
      }, { passive: true });
    }
    refresh();
  }

  /* ---------- drawer: butoanele „Adaugă” de la recomandari ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.vn-up__b');
    if (!b) return;
    e.preventDefault();
    var ids = (b.dataset.ids || b.dataset.id || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
    if (!ids.length) return;
    addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }), b);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProduct);
  else initProduct();
})();
